import { useEffect, useRef } from "react";

const INDEX = [
  ["Date", "13 April 2027"],
  ["Venue", "Grieghallen, Bergen"],
  ["Audience", "700 seats · invitation-led"],
  ["Format", "One day. One room. One programme."],
];

/* Grieghallen drifts slower than the page (parallax) — depth without gimmick. */
const useParallax = (ref) => {
  useEffect(() => {
    const el = ref.current;
    if (!el || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    let raf = 0;
    const on = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const y = Math.min(window.scrollY, window.innerHeight);
        el.style.transform = `translate3d(0, ${y * 0.22}px, 0)`;
      });
    };
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => { window.removeEventListener("scroll", on); cancelAnimationFrame(raf); };
  }, [ref]);
};

export const Hero = () => {
  const media = useRef(null);
  useParallax(media);
  return (
    <section className="ns-hero" data-testid="ns-hero">
      <div className="ns-hero-media" ref={media}>
        <img className="ns-photo" src="/images/grieghallen.webp" alt="Grieghallen, Bergen, at dusk" fetchPriority="high" />
      </div>
      <div className="ns-shade" aria-hidden />
      <div className="ns-wrap">
        <p className="ns-hero-eye" data-rv data-testid="ns-hero-eyebrow">The 2027 edition</p>
        <h1 className="ns-h1" data-testid="ns-hero-title"><span>The Next Shift.</span></h1>
        <p className="ns-hero-sub" data-rv style={{ "--d": ".45s" }} data-testid="ns-hero-sub">
          <span className="l1">One day. One room. 700 of Norway's leaders.</span>
          A national AI arena, built from Bergen — for the people deciding how AI is built, bought and governed.
        </p>
        <div className="ns-hero-cta" data-rv style={{ "--d": ".6s" }}>
          <a className="ns-btn" href="#invite" data-testid="ns-hero-cta">Request an invitation<span className="ar">→</span></a>
          <a className="ns-btn ghost" href="#partners" data-testid="ns-hero-partner-link">Partner with us</a>
        </div>
        <div className="ns-hero-index" data-rv style={{ "--d": ".8s" }} data-testid="ns-hero-index">
          {INDEX.map(([k, v]) => <span key={k}><i className="k">{k}</i>{v}</span>)}
        </div>
      </div>
    </section>
  );
};
